//src/styles/typography/weights.js
/**
 * Font weight configuration
 */

export const fontWeight = {
  thin: 100,
  hairline: 100,
  extraLight: 200,
  ultraLight: 200,
  light: 300,
  normal: 400,
  regular: 400,
  medium: 500,
  semiBold: 600,
  demibold: 600,
  bold: 700,
  extraBold: 800,
  ultraBold: 800,
  black: 900,
  heavy: 900,
};

export const typographyWeights = {
  display: fontWeight.bold,
  heading1: fontWeight.semiBold,
  heading2: fontWeight.semiBold,
  heading3: fontWeight.medium,
  heading4: fontWeight.medium,
  heading5: fontWeight.medium,
  heading6: fontWeight.medium,
  subtitle: fontWeight.regular,
  body: fontWeight.regular,
  caption: fontWeight.light,
  button: fontWeight.medium,
  overline: fontWeight.medium,
};

export const getFontWeight = (weight, fallback = fontWeight.regular) => {
  return fontWeight[weight] || fallback;
};

export const getTypographyWeight = (variant, fallback = fontWeight.regular) => {
  return typographyWeights[variant] || fallback;
};

export const isValidWeight = (weight) => {
  return Object.values(fontWeight).includes(weight);
};

export const getWeightName = (value) => {
  const entry = Object.entries(fontWeight).find(([_, val]) => val === value);
  return entry ? entry[0] : 'regular';
};

// No default export